import React from "react";
import { Navigate, Route, Routes as RouterRoutes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import LandingPage from './pages/landing-page';
import Terms from './pages/legal/Terms';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import RefundPolicy from './pages/legal/RefundPolicy';
import CookiePolicy from './pages/legal/CookiePolicy';
import InterviewConsent from './pages/legal/InterviewConsent';
import BetaDisclaimer from './pages/legal/BetaDisclaimer';

const Routes = () => {
  return (
    <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/landing-page" element={<Navigate to="/" replace />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/refund" element={<RefundPolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/interview-consent" element={<InterviewConsent />} />
        <Route path="/beta-disclaimer" element={<BetaDisclaimer />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </RouterRoutes>
    </ErrorBoundary>
  );
};

export default Routes;
